import React, { useEffect, useState } from 'react';
import { Trophy, X, Star, Award, Target, Flame } from 'lucide-react';
import { playAchievementSound } from '../utils/sounds';

const AchievementNotification = ({ achievement, onClose }) => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    if (achievement) {
      playAchievementSound();
      setIsVisible(true);

      // Auto close after 5 seconds
      const timer = setTimeout(() => {
        handleClose();
      }, 5000);

      return () => clearTimeout(timer);
    }
  }, [achievement]);

  const handleClose = () => {
    setIsVisible(false);
    setTimeout(() => {
      onClose();
    }, 300);
  };

  if (!achievement) return null;

  const getIcon = () => {
    if (achievement.title.includes("Racha") || achievement.title.includes("Perfeccionista")) {
      return <Flame className="w-8 h-8 text-amber-500" />;
    }
    if (achievement.title.includes("Precisión")) {
      return <Target className="w-8 h-8 text-blue-500" />;
    }
    if (achievement.title.includes("puntos")) {
      return <Trophy className="w-8 h-8 text-purple-500" />;
    }
    return <Star className="w-8 h-8 text-amber-500" />;
  };

  return (
    <div className="fixed inset-0 z-[100] pointer-events-none flex items-start justify-center pt-20 px-4">
      <div 
        className={`pointer-events-auto transform transition-all duration-300 ${
          isVisible ? 'translate-y-0 opacity-100' : '-translate-y-10 opacity-0'
        }`}
      >
        <div className="bg-gradient-to-r from-purple-500 to-pink-500 rounded-2xl shadow-2xl p-6 max-w-md w-full border-4 border-yellow-300 relative animate-bounce">
          {/* Close button */}
          <button
            onClick={handleClose}
            className="absolute top-2 right-2 p-1 rounded-lg hover:bg-white/20 transition-colors"
          >
            <X className="w-5 h-5 text-white" />
          </button>

          {/* Content */}
          <div className="flex items-center gap-4">
            {/* Icon */}
            <div className="bg-white rounded-2xl p-3 flex-shrink-0">
              {getIcon()}
            </div>

            {/* Text */}
            <div className="flex-1">
              <h3 className="text-white font-bold text-xl mb-1 flex items-center gap-2">
                <Trophy className="w-5 h-5" />
                ¡Logro Desbloqueado!
              </h3>
              <h4 className="text-yellow-200 font-bold text-lg mb-1">
                {achievement.title}
              </h4>
              <p className="text-white/90 text-sm">
                {achievement.description}
              </p>
            </div>
          </div>

          {/* Sparkle effects */}
          <div className="absolute -top-2 -right-2 animate-ping">
            <Star className="w-6 h-6 text-yellow-300 fill-yellow-300" />
          </div>
          <div className="absolute -bottom-2 -left-2 animate-ping delay-75">
            <Star className="w-5 h-5 text-yellow-300 fill-yellow-300" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default AchievementNotification;
